// src/hooks/useLiveLocation.js
import { useState, useEffect } from "react";

const useLiveLocation = () => {
  const [location, setLocation] = useState(
    localStorage.getItem("userLocation") || "",
  );
  const [coords, setCoords] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getLocation = () => {
      if (!navigator.geolocation) {
        setError("Geolocation is not supported by your browser.");
        setLoading(false);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setCoords({ latitude, longitude });

          try {
            const response = await fetch(
              `https://sakhisshop.com/api/location/reverse?lat=${latitude}&lon=${longitude}`,
            );
            const data = await response.json();

            if (!response.ok) throw new Error("Failed to fetch location info");

            const address = data.address;
            const place =
              address.suburb ||
              address.town ||
              address.village ||
              address.county ||
              address.state ||
              "Unknown location";

            setLocation(place);
            localStorage.setItem("userLocation", place);
          } catch (err) {
            setError("Error during reverse geocoding");
            console.error(err);
          } finally {
            setLoading(false);
          }
        },
        (err) => {
          setError(
            "Failed to retrieve location. Please allow location access.",
          );
          setLoading(false);
          console.warn("Geolocation error:", err);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    };

    setLoading(true);
    getLocation();
  }, []);

  return { location, coords, loading, error }; // ✅ Correct return
};

export default useLiveLocation;
